module.exports = __webpack_public_path__ + "img/eollogo.e2f7661d.png";